import {FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MatCard, MatCardContent} from "@angular/material/card";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatButton} from "@angular/material/button";
import {MatInput} from "@angular/material/input";
import {jwtDecode, JwtPayload} from "jwt-decode";
import {AuthService} from "../../auth/auth.service";
import {MatSnackBar} from "@angular/material/snack-bar";


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  imports: [
    MatCardContent,
    ReactiveFormsModule,
    MatFormField,
    MatButton,
    MatInput,
    MatLabel,
    MatCard,
    FormsModule,
  ],
  standalone: true,
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public form: FormGroup;
  private returnUrl: string;
  private ipAddress: string;

  username: string = "";
  password: string = "";
  message: string = "";

  constructor(private authService: AuthService,
              private route: ActivatedRoute,
              private router: Router,
              private snackBar: MatSnackBar) {
  }


  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  public login(): void {
    localStorage.removeItem("app.token");

    this.authService.login(this.username, this.password)
      .subscribe({
        next: (token) => {
          localStorage.setItem("app.token", token);

          const decodedToken = jwtDecode<JwtPayload>(token);
          // @ts-ignore
          localStorage.setItem("app.roles",  decodedToken.scope);

          // this.router.navigateByUrl("/persons");

          // this.router.navigate([this.returnUrl]);
          this.router.navigate([this.route.snapshot.queryParams['returnUrl'] || '/']);
        },
        error: (error) => {
          this.snackBar.open(`Login failed: ${error.status}`, "OK")
        }
      });
  }

}
